module.exports = __webpack_public_path__ + "media/images/smart_phone/item/btn_post_ov-745fffa809e55ea13492ffb9fc06222b.png";